import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=61780603&scoped=true&"
import script from "./PublicPage.vue?vue&type=script&lang=ts&"
export * from "./PublicPage.vue?vue&type=script&lang=ts&"
import style0 from "./PublicPage.vue?vue&type=style&index=0&id=61780603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61780603",
  null
  
)

export default component.exports